//jscs:disable maximumNumberOfLines, maximumLineLength
'use strict';

angular.module('AcaApp').directive('ngImportMapping', [
  '$mdDialog',
  '$timeout',
  '$window',
  'ImportMappingService',
  'AuxiliaryOperationsService',
  'FORM_MESSAGES',
  'SETTINGS',
  function($mdDialog, $timeout, $window, ImportMappingService, AuxiliaryOperationsService, FORM_MESSAGES, SETTINGS){
    return {
      restrict: 'E',
      templateUrl: 'app/views/common/directives/import/import-mapping.html',
      scope: {
        fileName: '@',
        sourceFieldsFromSampler: '=sourceFields',
        destinationFieldsFromDB: '=destinationFields',
        mapFields: '=mapFields',
        cancelCallback: '&',
        successMappingCallback: '&',
        importMapNamesFromDB: '=importMapNames',
        importMapsFromDB: '=importMaps',
        mode: '=mode',
        mapName: '=mapName',
        formType: '=formType',
        participant: '=participant',
        employer: '=employer',
        newData: '=newData',
        isSovosProfile: '=isSovosProfile'
      },
      link: function($scope, element){
        var mapNameOld = '';
        var initSourceFields = function(){
          $scope.sourceFields = _.map($scope.sourceFieldsFromSampler, function(sourceField){
            return {
              name: sourceField.name,
              fname: sourceField.name,
              mapped: false
            };
          });
        };
        //jscs:disable validateNewlineAfterArrayElements
        var requiredRecipFields = ['ACCOUNTNO', 'ADDRESS', 'CITY', 'TIN', 'NAME', 'ZIP', 'BIRTHDATE', 'STATE', 'NAME2'];
        var requiredFormFieldsB = ['FK2', 'FK1','payerid','C13', 'S01', 'C14'];
        var requiredFormFieldsC = ['FK2', 'FK1','payerid', 'C13'];
        if($window.sessionStorage.taxYear > 2019) requiredFormFieldsC.push('S02');
        var requiredPayerFields = ['PTIN'];
        var initDestinationFields = function(){
          $scope.destinationFields = _.map($scope.destinationFieldsFromDB, function(destinationField){
            if(destinationField.fname){
              destinationField.mapped = false;
            }
            return destinationField;
          });
        };

        var initMappedFields = function(){
          var gmlAlreadyProcessed = false;
          _.each($scope.mapFields, function(field){
            if(field.TargetField !== 'FK1' && field.TargetField !== 'FK2') {
              for(var i = 0; i < $scope.sourceFields.length; i++) {
                if($scope.sourceFields[i].fname == field.SourceField) {
                  $scope.currentMatchSource = $scope.sourceFields[i];
                  $scope.sourceFields[i].mapped = true;

                  for(var i = 0; i < $scope.destinationFields.length; i++) {
                    if(($scope.destinationFields[i].fname == field.TargetField) && (
                          ($scope.destinationFields[i].type == $scope.formType) ||
                          (($scope.destinationFields[i].type === 'Participant') && $scope.participant === 'true') ||
                          (($scope.destinationFields[i].type === 'Employer') && $scope.employer === 'true') ||
                          ((field.TargetField === 'TIN' && $scope.participant === 'false' && $scope.destinationFields[i].type === 'Mandatory') ||
                            (field.TargetField === 'ACCOUNTNO' && $scope.participant === 'false' && $scope.destinationFields[i].type === 'Mandatory') ||
                            (field.TargetField === 'GML' && $scope.participant === 'false' && $scope.destinationFields[i].type === 'Mandatory') ||
                            (field.TargetField === 'GRIDENTIFICATIONNUM' && $scope.participant === 'false' && $scope.destinationFields[i].type === 'Mandatory'))
                       )
                    ) {
                      $scope.currentMatchDestination = $scope.destinationFields[i];
                      if($scope.mode !== 'create'){
                        $scope.currentMatchSource.filterType = field.FilterType;
                        $scope.currentMatchSource.filterParams = field.FilterParams;
                        $scope.currentMatchSource.labelName = (field.SourceField === FORM_MESSAGES.FILTERFIXEDVALUE) ? field.SourceField + ': "' + field.FilterParams + '"' : '';
                        $scope.fixedValueFlag = (field.SourceField === FORM_MESSAGES.FILTERFIXEDVALUE);
                        $scope.labelFilter = (field.FilterType === '' || field.FilterType === undefined) ? FORM_MESSAGES.LABELFILTERADD : FORM_MESSAGES.LABELFILTEREDIT;
                      }
                      $scope.destinationFields[i].mapped = true;

                      if(field.TargetField !== 'GML' || !gmlAlreadyProcessed){
                        createMatchingRow();
                      }

                      if(field.TargetField === 'GML' && !gmlAlreadyProcessed){
                        gmlAlreadyProcessed = true;
                      }
                    }
                  }
                }
              }
            }
          });
          $scope.currentMatchSource = null;
          $scope.currentMatchDestination = null;
        };

        var findElementInFieldArrayByFname = function(fname, fchar, array){
          return _.find(array, function(item){
            if(item.fname == fname && item.type == fchar) {
              return true;
            }
          });
        };

        var checkMatchCondition = function(){
          $scope.matchEnabled = (($scope.currentMatchSource) && ($scope.currentMatchDestination)) ? true : false;
        };

        var clearCurrentMatch = function(){
          $scope.currentMatchSource = '';
          $scope.currentMatchDestination = '';
          checkMatchCondition();
        };

        var sourceFieldSelect = function(closestLi){
          if(closestLi.hasClass('selected')){
            $scope.currentMatchSource = null;
          }
          else{
            $scope.currentMatchSource = findElementInFieldArrayByFname(closestLi.data('fname'), closestLi.data('type'), $scope.sourceFields);
            $scope.currentMatchSource.labelName = '';
          }
          closestLi.toggleClass('selected');
          checkMatchCondition();
        };

        var destinationFieldSelect = function(closestLi){
          if(closestLi.hasClass('selected')){
            $scope.currentMatchDestination = null;
          }
          else{
            $scope.currentMatchDestination = findElementInFieldArrayByFname(closestLi.data('fname'), closestLi.data('type'), $scope.destinationFields);
          }
          closestLi.toggleClass('selected');
          checkMatchCondition();
        };

        var createMatchingRow = function(){
          $scope.mappedFields.push({
            source: angular.copy($scope.currentMatchSource.name),
            sourceFName: angular.copy($scope.currentMatchSource.fname),
            destination: angular.copy($scope.currentMatchDestination.name),
            destinationFName: angular.copy($scope.currentMatchDestination.fname),
            destinationFType: angular.copy($scope.currentMatchDestination.ftype),
            destinationType: angular.copy($scope.currentMatchDestination.type),
            filterType: angular.copy(($scope.currentMatchSource.filterType !== undefined) ? $scope.currentMatchSource.filterType : ''),
            filterParams: angular.copy(($scope.currentMatchSource.filterParams !== undefined) ? $scope.currentMatchSource.filterParams : ''),
            fixValueArray: ($scope.fixedValueFlag),
            labelLinkFilter: $scope.labelFilter,
            labelName: angular.copy($scope.currentMatchSource.labelName)
          });
          $scope.fixedValueFlag = false;
        };

        var clearSelectedFields = function(){
          var selectedFields = angular.element(element).find('.fields li.selected');
          selectedFields.removeClass('selected');
        };

        var markFieldsAsMapped = function(){
          $scope.currentMatchSource.mapped = true;
          $scope.currentMatchDestination.mapped = true;
        };

        var unMarkRemovedMatchingRow = function(index, fields, type){
          var itemFound = _.find(fields, function(item){
            if(item.fname === $scope.mappedFields[index][type] && item.mapped === true) {
              return true;
            }
          });
          itemFound.mapped = false;
        };

        var prepareFieldMappingForBackend = function(){
          $scope.mappedFieldsParticipant.length = 0;
          $scope.mappedFieldsForm.length = 0;
          $scope.mappedFieldsEmployer.length = 0;

          _.each($scope.mappedFields, function(field){
            var fieldBE = {
              'SourceField': field.sourceFName,
              'TargetField': field.destinationFName,
              'Type': field.destinationFType,
              'FilterType': (field.filterType !== undefined) ? field.filterType : '',
              'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
            };

            switch(field.destinationType){
              case 'Participant':
                if((field.destinationFName === 'TIN' ||
                  field.destinationFName === 'ACCOUNTNO' ||
                  field.destinationFName === 'GML' ||
                  field.destinationFName === 'GRIDENTIFICATIONNUM') && $scope.formType !== 'true'){
                  saveMandatory(field);
                }
                else{
                  $scope.mappedFieldsParticipant.push(fieldBE);
                }
                break;
              case 'Employer':
                $scope.mappedFieldsEmployer.push(fieldBE);
                break;
              case 'X5B':
              case 'X5C':
                $scope.mappedFieldsForm.push(fieldBE);
                break;
              case 'Mandatory':
                saveMandatory(field);
                break;
            }
          });
        };

        var saveMandatory = function(field){
          if(field.destinationFName === 'TIN'){
            $scope.mappedFieldsParticipant.push({
              'SourceField': field.sourceFName,
              'TargetField': field.destinationFName,
              'Type': field.destinationFType,
              'FilterType': (field.filterType !== undefined) ? field.filterType : '',
              'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
            });
            if(field.filterParams !== undefined && field.filterType === 'No TIN'){
              $scope.mappedFieldsParticipant.push(addDuplicateRowToTin(field, 'participant'));
            }
            if($scope.mappingOptions.importForm !== 'false'){
              $scope.mappedFieldsForm.push({
                'SourceField': field.sourceFName,
                'TargetField': 'FK1',
                'Type': field.destinationFType,
                'FilterType': (field.filterType !== undefined) ? field.filterType : '',
                'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
              });
              if(field.filterParams !== undefined && field.filterType === 'No TIN'){
                $scope.mappedFieldsForm.push(addDuplicateRowToTin(field, 'form'));
              }
            }
          }
          if(field.destinationFName === 'ACCOUNTNO'){
            $scope.mappedFieldsParticipant.push({
              'SourceField': field.sourceFName,
              'TargetField': field.destinationFName,
              'Type': field.destinationFType,
              'FilterType': (field.filterType !== undefined) ? field.filterType : '',
              'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
            });

            if($scope.mappingOptions.importForm !== 'false'){
              $scope.mappedFieldsForm.push({
                'SourceField': field.sourceFName,
                'TargetField': 'FK2',
                'Type': field.destinationFType,
                'FilterType': (field.filterType !== undefined) ? field.filterType : '',
                'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
              });
            }
          }
          if(field.destinationFName === 'GML'){
            $scope.mappedFieldsParticipant.push({
              'SourceField': field.sourceFName,
              'TargetField': field.destinationFName,
              'Type': field.destinationFType,
              'FilterType': (field.filterType !== undefined) ? field.filterType : '',
              'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
            });
            if($scope.mappingOptions.importForm !== 'false'){
              $scope.mappedFieldsForm.push({
                'SourceField': field.sourceFName,
                'TargetField': 'GML',
                'Type': field.destinationFType,
                'FilterType': (field.filterType !== undefined) ? field.filterType : '',
                'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
              });
            }
          }
          if(field.destinationFName === 'GRIDENTIFICATIONNUM'){
            $scope.mappedFieldsParticipant.push({
              'SourceField': field.sourceFName,
              'TargetField': field.destinationFName,
              'Type': field.destinationFType,
              'FilterType': (field.filterType !== undefined) ? field.filterType : '',
              'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
            });
            if($scope.mappingOptions.importForm !== 'false'){
              $scope.mappedFieldsForm.push({
                'SourceField': field.sourceFName,
                'TargetField': 'S08',
                'Type': field.destinationFType,
                'FilterType': (field.filterType !== undefined) ? field.filterType : '',
                'FilterParams': (field.filterParams !== undefined) ? field.filterParams : ''
              });
            }
          }
        };

        var prepareMapName = function(){
          if($scope.mappingOptions.importNewData === 'false'){
            $scope.mappingOptions.mapName = SETTINGS.CORRECTIONMAPS + $scope.mappingOptions.mapName;
          }
        };

        var prepareMappingForBackend = function(){
          prepareFieldMappingForBackend();
          $scope.mappingBEFormat = {
            'Name': angular.copy($scope.mappingOptions.mapName),
            'FileType': 'Excel',
            'MapParams': {
              'Fchar': $scope.mappingOptions.importForm,
              'Participant': $scope.mappingOptions.importParticipant,
              'Employer': $scope.mappingOptions.importEmployer,
              'NewData': $scope.mappingOptions.importNewData
            }
          };
          if($scope.mappedFieldsEmployer.length > 0){
            $scope.mappingBEFormat['MapFields_0'] = $scope.mappedFieldsEmployer;
          }
          if($scope.mappedFieldsParticipant.length > 0){
            $scope.mappingBEFormat['MapFields_1'] = $scope.mappedFieldsParticipant;
          }
          if($scope.mappedFieldsForm.length > 0){
            $scope.mappingBEFormat['MapFields_' + $scope.mappingOptions.importForm] = $scope.mappedFieldsForm;
          }
        };

        $scope.mappingOptions = {
          importParticipant: $scope.participant,
          importEmployer: $scope.employer,
          mapName: $scope.mapName,
          importForm: $scope.formType,
          importNewData: $scope.newData
        };
        $scope.showRequired = false;
        $scope.currentMatchSource = null;
        $scope.currentMatchDestination = null;
        $scope.matchEnabled = false;
        $scope.filters = {
          sourceUnmatched: false,
          destinationUnmatched: false
        };
        $scope.mappedFields = [];
        //$scope.mappedFieldsBEFormat = [];
        $scope.mappedFieldsParticipant = [];
        $scope.mappedFieldsEmployer = [];
        $scope.mappedFieldsForm = [];
        $scope.fixedValue = '';
        $scope.filtersMap = [
          {id: 'No TIN', name: 'No TIN'},
          {id: 'Convert', name: 'Convert'},
          {id: 'Float', name: 'Float'},
          {id: 'Date', name: 'Date'},
          {id: 'Pad', name: 'Pad'},
          {id: 'IF', name: 'IF'}
        ];
        $scope.messageFilterError = '';
        $scope.showMessageFilterError = false;
        $scope.labelFilter = FORM_MESSAGES.LABELFILTERADD;
        $scope.showDateFormatOptions = false;

        initSourceFields();
        initDestinationFields();
        initMappedFields();

        $scope.mapFieldClick = function(ev, type){
          var selectedLiItems = angular.element(element).find('.' + type + '-section .fields li.selected');
          var closestLi = angular.element(ev.currentTarget);
          var fieldsArray = (type === 'source') ? $scope.sourceFields : $scope.destinationFields;
          var selectedField = findElementInFieldArrayByFname(closestLi.data('fname'), closestLi.data('type'), fieldsArray);
          if(selectedField && !selectedField.mapped) {
            if(selectedLiItems.length > 0 && !closestLi.hasClass('selected')) {
              selectedLiItems.removeClass('selected');
            }
            if(type === 'source'){
              sourceFieldSelect(closestLi);
            }
            else{
              destinationFieldSelect(closestLi);
            }
          }
        };

        $scope.clearMatchClick = function(){
          clearCurrentMatch();
          clearSelectedFields();
        };

        $scope.matchFields = function(){
          AuxiliaryOperationsService.RenewToken().then(function(){
          });
          markFieldsAsMapped();
          createMatchingRow();
          clearCurrentMatch();
          clearSelectedFields();
        };

        $scope.matchFieldsByName = function(){
          AuxiliaryOperationsService.RenewToken().then(function(){
          });
          createMatchingRowByName();
        };

        var createMatchingRowByName = function(){
          var foundField;
          var participant = $scope.mappingOptions.importParticipant === 'true' ? 'Participant' : 'Mandatory';
          var employer = $scope.mappingOptions.importEmployer === 'true' ? 'Employer' : 'NotEmployer';
          _.each($scope.destinationFields, function(destField){
             if ((destField.type === $scope.mappingOptions.importForm) || (destField.type === participant && $scope.mappingOptions.importEmployer !== 'true') || (destField.type === employer)){
              _.each($scope.sourceFields, function(sourceField){
                if((sourceField.name == destField.name) || (sourceField.name == destField.fname) ||
                  ((sourceField.name === 'PTIN') && (destField.fname === 'payerid')) || 
                  ((sourceField.name === 'STATUS') && (destField.fname === 'C13')) ||
                  ((sourceField.name === 'PLANSTARTMONTH') && (destField.fname === 'S02')) ||
                  ((sourceField.name === 'EMPLOYERSPONSOR') && (destField.fname === 'S01')) ||
                  ((sourceField.name === 'ORIGINOFPOLICY') && (destField.fname === 'C14')) ||
                  ((((sourceField.name === 'NEWTIN') && (destField.fname === 'GRIDENTIFICATIONNUM')) ||
                  ((sourceField.name === 'NEWORIGINOFPOLICY') && (destField.fname === 'DC01')) ||
                  ((sourceField.name === 'NEWEMPLOYERSPONSOR') && (destField.fname === 'S07'))) && ($scope.mappingOptions.importNewData === 'false'))){
                  $scope.currentMatchSource = sourceField;
                  $scope.currentMatchDestination = destField;
                  markFieldsAsMapped();
                };
                foundField = _.find($scope.mappedFields, function(fieldExist){
                  return fieldExist.destinationFName == destField.fname;
                });
                checkMatchCondition();
                if($scope.matchEnabled && !foundField){
                  $scope.mappedFields.push({
                    source: angular.copy($scope.currentMatchSource.name),
                    sourceFName: angular.copy($scope.currentMatchSource.fname),
                    destination: angular.copy($scope.currentMatchDestination.name),
                    destinationFName: angular.copy($scope.currentMatchDestination.fname),
                    destinationFType: angular.copy($scope.currentMatchDestination.ftype),
                    destinationType: angular.copy($scope.currentMatchDestination.type),
                    filterType: angular.copy(($scope.currentMatchSource.filterType !== undefined) ? $scope.currentMatchSource.filterType : ''),
                    filterParams: angular.copy(($scope.currentMatchSource.filterParams !== undefined) ? $scope.currentMatchSource.filterParams : ''),
                    fixValueArray: ($scope.fixedValueFlag),
                    labelLinkFilter: $scope.labelFilter,
                    labelName: angular.copy($scope.currentMatchSource.labelName)
                  });
                };
                clearCurrentMatch();
                $scope.fixedValueFlag = false;
              });
            };
          });
        };

        $scope.checkSourceMappedFilter = function(field){
          if(!$scope.filters.sourceUnmatched) {
            return true;
          }
          else{
            return (!field.mapped);
          }
        };

        $scope.showCancel = function(event){
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: 'app/views/common/directives/import/cancelMapping.html',
            parent: angular.element(document.body),
            targetEvent: event
          });
        };

        $scope.cancelMappingConfirmation = function(){
          $mdDialog.hide();
          $scope.cancelCallback()();
        };

        $scope.closeModal = function(){
          $mdDialog.hide();
        };

        $scope.generateRecipArray = function(){
          $scope.fieldsRecip = _.map($scope.mappedFieldsParticipant, function(field){
            return field.TargetField;
          }
          );
        };

        $scope.generatePayerArray = function(){
          $scope.fieldsPayer = _.map($scope.mappedFieldsEmployer, function(field){
            return field.TargetField;
          });
        };

        $scope.generateFormArray = function(){
          $scope.fieldsForm = _.map($scope.mappedFieldsForm, function(field){
            return field.TargetField;
          }
          );
        };

        $scope.checkRequiredRecipFields = function(){
          $scope.generateRecipArray();
          var existingRequiredFields = _.intersection(requiredRecipFields, $scope.fieldsRecip);
          return angular.equals(requiredRecipFields, existingRequiredFields);
        };

        $scope.checkRequiredFormFields = function(){
          $scope.generateFormArray();
          if($scope.mappingOptions.importForm === 'X5C'){
            var existingRequiredFields = _.intersection(requiredFormFieldsC, $scope.fieldsForm);
            return angular.equals(requiredFormFieldsC, existingRequiredFields);
          }
          else{
            if($scope.mappingOptions.importForm === 'X5B'){
              var existingRequiredFields = _.intersection(requiredFormFieldsB, $scope.fieldsForm);
              return angular.equals(requiredFormFieldsB, existingRequiredFields);
            }
          }
        };

        $scope.checkRequiredPayerArray = function(){
          $scope.generatePayerArray();
          var existingRequiredFields = _.intersection(requiredPayerFields, $scope.fieldsPayer);
          return angular.equals(requiredPayerFields, existingRequiredFields);
        };

        $scope.checkMapping = function(){
          var hasRequiredRecipFields, hasRequiredFormFields, hasRequiredPayerFields;
          if($scope.mappingOptions.importParticipant === 'true'){
            hasRequiredRecipFields = $scope.checkRequiredRecipFields();
          }
          else{
            hasRequiredRecipFields = true;
          }
          if($scope.mappingOptions.importForm !== 'false'){
            hasRequiredFormFields = $scope.checkRequiredFormFields();
          }
          else{
            hasRequiredFormFields = true;
          }
          if($scope.mappingOptions.importEmployer === 'true'){
            hasRequiredPayerFields = $scope.checkRequiredPayerArray();
          }
          else{
            hasRequiredPayerFields = true;
          }
          if(hasRequiredRecipFields && hasRequiredFormFields && hasRequiredPayerFields){
            return true;
          }
          else{
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/import/modals/mapping-error.html',
              parent: angular.element(document.body)
            });
            return false;
          }
        };

        $scope.changeValueThreeAndFour = function(event){
          if(event.currentTarget.children[0].attributes[4].value === 'true') {
            $scope.mappingOptions.importParticipant = 'false';
            $scope.mappingOptions.importForm = 'false';
          }
        };

        $scope.errorMsj = function(error){
          //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
          if(error.data.error.frontend_code === 'DUPLICATED-SETTING'){
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/import/modals/duplicatedMap-error.html',
              parent: angular.element(document.body)
            });
          }
        };

        $scope.doneMapping = function(){
          prepareMappingForBackend();
          var isMappingOK = $scope.checkMapping();
          if(isMappingOK){
            prepareMapName();
            ImportMappingService.sendMapping($scope.mappingOptions.mapName, $scope.mappingBEFormat, $scope.mode).then(function(data){
              if(data.result.value === true){
                $scope.successMappingCallback()(data, $scope.mappingOptions.mapName, $scope.mappingOptions.importNewData);
              }
              else{
                console.log('Error while trying to save the import mapping');
              }
            }, function(error){
              $scope.mappingOptions.mapName = $scope.mappingOptions.mapName.replace(SETTINGS.CORRECTIONMAPS, '');
              $scope.errorMsj(error);
              console.log('Error on ', error);
            });
          };
        };

        $scope.checkDestinationMappedFilter = function(field){
          if(!$scope.filters.destinationUnmatched) {
            return true;
          }
          else{
            return (!field.mapped);
          }
        };

        $scope.checkEntityTypeFilter = function(field){
          if(field.type === 'Participant'){
            if(field.fname === 'GRIDENTIFICATIONNUM'){
              return ($scope.mappingOptions.importParticipant === 'true' && $scope.mappingOptions.importNewData === 'false');
            }
            else{
              return $scope.mappingOptions.importParticipant === 'true';
            }
          }
          if(field.type === 'X5C') {
            return ($scope.mappingOptions.importForm === 'X5C');
          }
          if(field.type === 'X5B') {
            if(field.fname === 'S07' || field.fname === 'DC01'){
              return ($scope.mappingOptions.importForm === 'X5B' && $scope.mappingOptions.importNewData === 'false');
            }
            else{
              return ($scope.mappingOptions.importForm === 'X5B');
            }
          }
          if(field.type === 'WithoutParticipant'){
            return ($scope.mappingOptions.importParticipant === 'false' && $scope.mappingOptions.importEmployer === 'false');
          }
          if(field.type === 'Employer'){
            return $scope.mappingOptions.importEmployer === 'true';
          }
          if(field.type === 'Mandatory') {
            if(field.fname === 'GRIDENTIFICATIONNUM'){
              return (($scope.mappingOptions.importForm === 'X5C' || $scope.mappingOptions.importForm === 'X5B') && $scope.mappingOptions.importParticipant === 'false' && $scope.mappingOptions.importNewData === 'false');
            }
            else{
              return (($scope.mappingOptions.importForm === 'X5C' || $scope.mappingOptions.importForm === 'X5B') && $scope.mappingOptions.importParticipant === 'false');
            }
          }
          if(field.type == 'X4B' || field.type == 'X4C'){
            return $scope.mappingOptions.importEmployer === 'true';
          }
          return true;
        };

        $scope.removeMatchingRow = function(ev, index){
          unMarkRemovedMatchingRow(index, $scope.sourceFields, 'sourceFName');
          unMarkRemovedMatchingRow(index, $scope.destinationFields, 'destinationFName');
          $scope.mappedFields.splice(index, 1);
        };

        $scope.okMappingOptions = function(form){
          if(!form.$valid){
            $scope.showRequiredMessage();
            return true;
          }
          if($scope.mappingOptions.importForm === undefined){
            $scope.errorMessage = FORM_MESSAGES.SELECTONEFORM;
            return true;
          }
          if($scope.mappingOptions.importParticipant === 'false' && $scope.mappingOptions.importForm === 'false' && $scope.mappingOptions.importEmployer === 'false'){
            $scope.errorMessage = FORM_MESSAGES.SELECTONEDATA;
            return true;
          }
          if($scope.validateMapName()){
            return true;
          }
          if($scope.mappingOptions.importNewData === undefined){
            $scope.errorMessage = FORM_MESSAGES.SELECTONEDATATYPE;
            return true;
          }
          $scope.errorMessage = '';
          $mdDialog.hide();
        };

        $scope.validateMapName = function(){
          $scope.mappingOptions.mapName = $scope.mappingOptions.mapName.replace(/ /g, '_');
          for(var i = 0; i < $scope.importMapsFromDB.length; i++) {
            if($scope.importMapsFromDB[i].SettingName === $scope.mappingOptions.mapName){
              $scope.errorMessage = FORM_MESSAGES.MAPNAMEALREADYEXISTS;
              return true;
            }
          }
          return false;
        };

        $scope.closeMappingOptions = function(){
          $mdDialog.hide();
          $scope.cancelCallback();
        };

        $scope.showRequiredMessage = function(){
          $scope.showRequired = true;
        };

        $timeout(
          function(){
            if($scope.mode !== 'create') {
              $mdDialog.hide();
              $scope.errorMessage = '';
            }
            else{
              $mdDialog.show({
                scope: $scope.$new(),
                templateUrl: 'app/views/common/directives/import/mappingOptions.html',
                parent: angular.element(document.body),
                targetEvent: null
              });
            }
          }
        );

        $scope.editMapNameModal = function($event){
          mapNameOld = $scope.mappingOptions.mapName;
          $scope.showRequired = false;
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: 'app/views/common/directives/import/editMapName.html',
            parent: angular.element(document.body),
            targetEvent: $event
          });
        };

        $scope.closeEditNameConfirmation = function(form){
          $scope.errorMessage = '';
          if($scope.validateMapName()){
            $scope.errorMessage = FORM_MESSAGES.MAPNAMEALREADYEXISTS;
            return true;
          }
          if(form.$valid){
            $mdDialog.hide();
          }
          $scope.showRequiredMessage();
        };

        $scope.closeEditNameModal = function(){
          $scope.mappingOptions.mapName = mapNameOld;
          $mdDialog.hide();
        };

        $scope.addFilter = function($event, filter, index){
          var filterSelected = '';
          var labelName = '';
          $scope.indexMatchFields = index;
          switch(filter){
            case 'fixedValue':
              $scope.modalTitle = FORM_MESSAGES.FILTERFIXEDVALUE;
              $scope.fixedValueFlag = true;
              break;
            case 'filters':
              $scope.modalTitle = 'Filters';
              $scope.fixedValueFlag = false;
              labelName = $scope.mappedFields[$scope.indexMatchFields]['destination'];
              $scope.destiantionName = labelName.replace('*', '') ;
              $scope.fixedValue = $scope.mappedFields[$scope.indexMatchFields]['filterParams'];
              filterSelected = ($scope.mappedFields[$scope.indexMatchFields]['filterType'] !== '');
              $scope.filtersSelected = filterSelected ? $scope.mappedFields[$scope.indexMatchFields]['filterType'] : '';
              $scope.showDateFormatOptions = ($scope.filtersSelected === 'Date');
              break;
          }
          $mdDialog.show({
            scope: $scope,
            preserveScope: true,
            templateUrl: 'app/views/common/directives/import/addFilter.html',
            parent: angular.element(document.body),
            targetEvent: $event
          });
        };

        $scope.closeModalFilters = function(){
          $scope.fixedValue = '';
          $scope.messageFilterError = '';
          $scope.showMessageFilterError = false;
          $scope.fixedValueFlag = false;
          $mdDialog.hide();
        };

        $scope.addFixedValue = function(){
          if($scope.fixedValue !== '' && $scope.filtersSelected !== ''){
            if($scope.fixedValueFlag){
              $scope.currentMatchSource = {
                fname: FORM_MESSAGES.FILTERFIXEDVALUE,
                mapped: false,
                name: $scope.fixedValue,
                labelName: FORM_MESSAGES.FILTERFIXEDVALUE + ': "' + $scope.fixedValue + '"'
              };
              $scope.sourceFields.push($scope.currentMatchSource);
              checkMatchCondition();
              $scope.currentMatchSource.filterType = '=';
              $scope.currentMatchSource.filterParams = $scope.fixedValue;
            }
            else{
              var fields = $scope.destinationFields;
              var type = 'destinationFName';
              _.find(fields, function(item){
                if(item.fname === $scope.mappedFields[$scope.indexMatchFields][type] && item.mapped === true){
                  item.filterType = $scope.filtersSelected;
                  item.labelLinkFilter = FORM_MESSAGES.LABELFILTEREDIT;
                  item.labelName = '';
                  $scope.mappedFields[$scope.indexMatchFields]['filterType'] = $scope.filtersSelected;
                  $scope.mappedFields[$scope.indexMatchFields]['filterParams'] = $scope.fixedValue;
                  $scope.mappedFields[$scope.indexMatchFields]['labelLinkFilter'] = FORM_MESSAGES.LABELFILTEREDIT;
                  $scope.mappedFields[$scope.indexMatchFields]['labelName'] = '';
                  return true;
                }
              });
            }
            $scope.fixedValue = '';
            $scope.messageFilterError = '';
            $scope.showMessageFilterError = false;
            $scope.closeModal();
          }
          else{
            if($scope.fixedValue === '' && $scope.filtersSelected !== ''){
              $scope.showMessageFilterError = true;
              $scope.messageFilterError = FORM_MESSAGES.FILTERVALUE;
            }
            if($scope.fixedValue !== '' && $scope.filtersSelected === ''){
              $scope.showMessageFilterError = true;
              $scope.messageFilterError = FORM_MESSAGES.FILTERFIELD;
            }
            if($scope.fixedValue === '' && $scope.filtersSelected === ''){
              $scope.mappedFields[$scope.indexMatchFields]['filterType'] = $scope.filtersSelected;
              $scope.mappedFields[$scope.indexMatchFields]['filterParams'] = $scope.fixedValue;
              $scope.mappedFields[$scope.indexMatchFields]['labelLinkFilter'] = FORM_MESSAGES.LABELFILTERADD;
              $scope.mappedFields[$scope.indexMatchFields]['labelName'] = '';
              $scope.closeModal();
            }
          }
        };

        $scope.checkFilterDate = function(){
          $scope.fixedValue= '';
          $scope.showDateFormatOptions = ($scope.filtersSelected === 'Date');
        };

        var addDuplicateRowToTin = function(field, typeEntity){
          var itemCopy = {
            FilterParams: '',
            FilterType: '',
            SourceField: field.sourceFName,
            TargetField: (typeEntity === 'participant') ? 'TIN' : 'FK1',
            Type: 'STRING'
          };
          return itemCopy;
        };
      }
    };
  }
]);
